package nl.astraeus.midi.symbols

import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement

fun CanvasRenderingContext2D.drawBravura(
  symbol: String,
  x: Double = 25.0,
  y: Double = 150.0
) {
  this.font = "120px Bravura"
  this.fillStyle = "black"
  this.strokeStyle = "black"

  this.fillText(symbol, x, y)
}

fun createBravura(symbol: String): HTMLCanvasElement {
  val (canvas, ctx) = createCanvasCtx()

  ctx.drawBravura(symbol)

  return canvas
}
